import * as React from 'react';
import { inject, observer } from 'mobx-react';
import * as styles from './ApplicationsSettings.css';
import { IAChoiceGroup } from './../../../choiceGroup/ChoiceGroup';
import { IACheckbox } from './../../../checkbox/Checkbox';
import { IAButton } from '../../../button/Button';
import { TreeTargeting } from './../../../treeTargeting/TreeTargeting';
import { TargetingAdminStore } from '../../stores/TargetingAdminStore';
import { Environment } from './../../../../services/Environment';
import { IAToggle } from './../../../toggle/Toggle';
import { IApplication, Instance } from './../../../../interfaces/IApplication';
import { TargetingService } from './../../../../services/TargetingService';
import { LocalizationService } from './../../../../services/LocalizationService';
import { IAPanel } from '../../../panels/Panel';
import { IATooltip } from './../../../tooltip/Tooltip';
import { IAIcon } from '../../../icon/Icon';
import { ITargetingExistingStrucuture } from '../../../../interfaces/ITargetingExistingStructure';
import { ContentOrganizerStore } from '../../../contentOrganizerWizard/stores';

export interface ITargetingSettingsProps {
  targetingStore?: TargetingAdminStore;
  contentOrganizerStore?: ContentOrganizerStore;
  open: boolean;
  close: () => void;
  isApplication: boolean;
  application: IApplication;
  item: Instance;
  isMountOnMainPanel?: boolean;
  style?: React.CSSProperties;
}

export interface ITargetingSettingsState {
  radioValue: string;
  color: string;
  storedValues: Array<{ label: string, id: string, value?: boolean }>;
  allValues: boolean;
  useDefaultValues: boolean;
  enableTargeting: boolean;
  treeValues: Array<{ label: string, id: string, field?: string }>;
  isSaving: boolean;
  required: boolean;
  targetingExistingStructure: ITargetingExistingStrucuture;
}

@inject('targetingStore')
@observer
export class ApplicationsSettings extends React.Component<ITargetingSettingsProps, ITargetingSettingsState> {
  constructor(props: ITargetingSettingsProps, state: ITargetingSettingsState) {
    super(props, state);

    this.state = {
      radioValue: "profileData",
      color: "#025159",
      storedValues: [],
      allValues: false,
      useDefaultValues: false,
      enableTargeting: true,
      treeValues: [],
      isSaving: false,
      required: false,
      targetingExistingStructure: {
        useDefaultStructure: false,
        nodes: []
      }
    };

    if (this.props.targetingStore.language != undefined) {
      this.props.targetingStore.setLanguage(this.props.targetingStore.language);
    }
  }

  public componentWillReceiveProps(nextProps: ITargetingSettingsProps) {
    const treeValues: Array<{ label: string, id: string, field?: string }> = [];
    let required = false;
    let userGroups = [];
    if (nextProps.item) {
      if (this.props.targetingStore.groupsList && this.props.targetingStore.groupsList.length) {
        userGroups = this.props.targetingStore.groupsList.map((group) => {
          let storedGroup = nextProps.item.values.find(g => g.id === group.id);
          required = ((storedGroup && storedGroup.value) ? storedGroup.value : required);
          return { label: group.title, id: group.id, value: nextProps.item.allValues ? true : ((storedGroup && storedGroup.value) ? storedGroup.value : false) };
        });
      }

      if (nextProps.item.type === "profileData" && nextProps.item.values) {
        nextProps.item.values.forEach(value => {
          treeValues.push({ label: value.label, id: value.id, field: value.field });
        });
        if (treeValues.length > 0) {
          required = true;
        }
      }
      let radioValue = nextProps.application.default.type;
      if (nextProps.application.name.toLocaleLowerCase() === 'content organizer') {
        radioValue = nextProps.item.type;
      }
      if (nextProps.application.name.toLocaleLowerCase() === 'app') {
        radioValue = "profileData";
      }
      this.setState({ radioValue, allValues: nextProps.item.allValues, enableTargeting: nextProps.item.isEnable, useDefaultValues: nextProps.item.useDefault, storedValues: userGroups, treeValues, required });
    } else {
      if (this.props.targetingStore.groupsList && nextProps.application) {
        if (this.props.targetingStore.groupsList && this.props.targetingStore.groupsList.length) {
          userGroups = this.props.targetingStore.groupsList.map((group) => {
            let storedGroup = nextProps.application && nextProps.application.default && nextProps.application.default.values ? nextProps.application.default.values.find(g => g.id === group.id) : undefined;
            required = ((storedGroup && storedGroup.value) ? storedGroup.value : required);
            return { label: group.title, id: group.id, value: nextProps.application.default.allValues ? true : ((storedGroup && storedGroup.value) ? storedGroup.value : false) };
          });
        }
        if (nextProps.application.default.type === "profileData" && nextProps.application.default.values) {
          nextProps.application.default.values.forEach(value => {
            treeValues.push({ label: value.label, id: value.id, field: value.field });
          });
          if (treeValues.length > 0) {
            required = true;
          }
        }

        this.setState({ radioValue: nextProps.application.default.type, allValues: nextProps.application.default.allValues, enableTargeting: nextProps.application.default.isEnable, useDefaultValues: false, storedValues: userGroups, treeValues, required });
      }
    }
  }

  public render(): JSX.Element {
    if (!this.props.application) {
      return (<div></div>);
    }


    // let listGroups: {name: string, value: boolean}[] = [];

    let panel = (
      <div style={this.props.style} className={styles.IA_viewPanelContentWrapper}>
        <div style={{ marginTop: '10px', marginBottom: '20px', fontWeight: 600, fontSize: '17px' }}>{this.props.isMountOnMainPanel ? "" : !this.props.item ? this.props.application.name : `${this.props.application.name} - ${this.props.item.name}`}</div>
        {
          <div>
            <IAToggle
              label={new LocalizationService().strings.TargetingAdmin_ApplicationSettingsEnableTarget}
              checked={this.state.enableTargeting}
              onChange={() => {
                this.setState({ enableTargeting: !this.state.enableTargeting })
              }}
              style={{
                width: "unset"
              }}
              color={this.state.color}
            />
          </div>}
        {this.state.enableTargeting &&
          <div>
            {(!this.props.isApplication && this.props.application.name.toLocaleLowerCase() !== 'content organizer') &&
              <div style={{ marginTop: '10px', marginBottom: 20 }}>
                <IAToggle
                  label={`${new LocalizationService().strings.TargetingAdmin_ApplicationSettingsUseDefault}${this.props.application.name}`}
                  checked={this.state.useDefaultValues}
                  onChange={() => {
                    this.setState({ useDefaultValues: !this.state.useDefaultValues })
                  }}
                  style={{
                    width: "unset"
                  }}
                  color={this.state.color}
                />
              </div>
            }
            {((this.props.isApplication || this.props.application.name.toLocaleLowerCase() === 'content organizer') && this.props.application.name.toLocaleLowerCase() !== 'app') &&
              <div style={{ marginTop: '10px', marginBottom: '10px', display: 'flex', clear: 'both' }}>
                <IAChoiceGroup
                  // className={styles.IA_defaultChoiceGroup}
                  label={new LocalizationService().strings.TargetingAdmin_ApplicationSettingsSelectTarget}
                  selectedKey={this.state.radioValue}
                  highlightColor={this.state.color}
                  options={[
                    {
                      key: 'userGroups',
                      text: new LocalizationService().strings.TargetingAdmin_ApplicationSettingsUserGroups,
                      disabled: false
                    },
                    {
                      key: 'profileData',
                      text: new LocalizationService().strings.TargetingAdmin_ApplicationSettingsProfileData,
                      disabled: false
                    }
                  ]}
                  required={true}
                  onChange={(key) => {
                    let allValues = true;
                    let required = false;
                    if (key === 'userGroups') {

                      this.state.storedValues.forEach(item => {
                        if (!item.value) {
                          allValues = false;
                        } else {
                          required = true;
                        }
                      });
                    } else {
                      required = this.state.treeValues.length > 0 ? true : false
                      allValues = false;
                    }
                    this.setState({ radioValue: key, allValues, required })
                  }}
                  style={{
                    marginTop: 10
                  }}
                />
                <div style={{ position: 'relative', left: '5px', top: '15px' }}>
                  <IATooltip
                    content="Tooltip"
                    type={"bubble"}
                    styles={{
                      width: 300,
                      color: "#999999",
                      textAlign: "center",
                      marginBottom: "5px"
                    }}
                    componentContent={
                      <div>
                        <ul>
                          <li>{new LocalizationService().strings.TargetingAdmin_ApplicationSettingsInfo}</li>
                        </ul>
                      </div>
                    }>
                    <IAIcon
                      title="Info"
                      size={17}
                      color={this.props.targetingStore.highlightColor}
                      style={{
                        float: "left"
                      }} />
                  </IATooltip>
                </div>

              </div>
            }
            {(!this.state.useDefaultValues || this.props.isApplication || this.props.application.name.toLocaleLowerCase() === 'content organizer') && <div>
              {this.state.radioValue === 'userGroups' &&
                <div style={{ clear: 'both', float: "left", marginTop: 10 }}>
                  <div style={{ marginBottom: '10px' }}>
                    {new LocalizationService().strings.TargetingAdmin_ApplicationSettingsUserGroupsTarget}<span style={{ color: 'red' }}> *</span>
                  </div>
                  <IACheckbox
                    highlightColor={this.state.color}
                    isChecked={this.state.allValues}
                    label={new LocalizationService().strings.TargetingAdmin_ApplicationSettingsAll}
                    onChange={() => {
                      let value = !this.state.allValues;
                      let list = this.state.storedValues.map((group) => {
                        group.value = value;
                        return group;
                      });
                      this.setState({ allValues: value, storedValues: list, required: value });
                    }}
                  />
                  {this.state.storedValues.sort((g1, g2) => {
                    if (g1.label.toLocaleLowerCase() > g2.label.toLocaleLowerCase()) {
                      return 1;
                    }
                    if (g1.label.toLocaleLowerCase() < g2.label.toLocaleLowerCase()) {
                      return -1;
                    }
                    return 0;
                  }).map((group) => {
                    let checkGroup = (
                      <div>
                        <IACheckbox
                          highlightColor={this.state.color}
                          isChecked={group.value}
                          label={group.label}
                          styles={{ marginTop: 10 }}
                          onChange={() => {
                            let required = false;
                            let list = this.state.storedValues;
                            let item = list.find(x => x.id === group.id);
                            if (item) {
                              item.value = !group.value;
                            }
                            if (list.filter(x => x.value)) {
                              required = true;
                            }
                            const isAllChecked = !list.find(e => e.value === false);
                            this.setState({
                              storedValues: this.state.storedValues,
                              required,
                              allValues: isAllChecked
                            });
                          }}
                        />
                      </div>
                    );
                    return checkGroup;
                  })}

                </div>
              }
              {this.state.radioValue === 'profileData' &&
                <div style={{ marginBottom: '10px', clear: 'both' }}>
                  <div style={{ marginTop: 10, marginBottom: 10 }}>{new LocalizationService().strings.TargetingAdmin_ApplicationSettingsProfileDataTarget}<span style={{ color: 'red' }}> *</span></div>
                  { /* tslint:disable:no-unused-variable */}
                  <TreeTargeting
                    application={(this.props.application ? this.props.application.name.toLocaleLowerCase() : this.props.item.name.toLocaleLowerCase()) as "messages" | "navigator" | "toolbox" | "events" | "content organizer" | "app"}
                    label={new LocalizationService().strings.Messages_TargetContent}
                    tenant={`${this.props.targetingStore.tenant}.sharepoint.com`}
                    authToken={this.props.targetingStore.token}
                    environment={this.props.targetingStore.environment}
                    apiUrl={Environment.getEnvironmentForMainAPI(this.props.targetingStore.environment)}
                    currenNodeStructure={this.state.targetingExistingStructure}
                    selectedValues={this.state.treeValues} //Add stored data
                    showTarget={true}
                    onShowTargetChanged={() => { }}

                    onChange={
                      (targetingDataModel, applicationSettings, groupResult, selectAll, targetingExistingStructure) => {
                        const list: any[] = [];
                        targetingDataModel.forEach(items => {
                          list.push(...items.values);
                        });
                        this.setState({ treeValues: list, allValues: selectAll, required: list.length > 0 ? true : false, targetingExistingStructure: targetingExistingStructure });
                        console.log(applicationSettings, groupResult);
                      }}
                    operator={"AND"}
                    // tslint:disable-next-line: no-empty
                    onLogicalOperatorChanged={() => { }}
                    nodeComparison={"label"}
                    highlightColor={this.state.color}
                    hideOptions={true}
                    selectAll={this.state.allValues}
                    showSelectAll={true}
                    isAdmin={true}
                  />
                </div>
              }
            </div>}
          </div>
        }
        <div style={{ clear: 'both' }}></div>
        {!this.props.isMountOnMainPanel &&
          <div style={{ marginBottom: '20px', marginTop: '20px', float: "left" }}>
            <IAButton
              style={{ float: 'left' }}
              buttonColor={this.props.targetingStore.highlightColor}
              label={new LocalizationService().strings.TargetingAdmin_ApplicationSettingsSave}
              disbaled={this.state.isSaving || (this.state.enableTargeting && !this.state.required && !this.state.useDefaultValues)}
              showSpinner={this.state.isSaving}
              onClick={() => {
                this.cleanTargetingExistingStructure();
                let selected = false;
                if (this.state.radioValue === "userGroups") {
                  this.state.storedValues.forEach(item => {
                    if (item.value) {
                      selected = true;
                    }
                  })
                } else {
                  if (this.state.treeValues && this.state.treeValues.length > 0) {
                    selected = true;
                  }
                }
                if (selected || !this.state.enableTargeting || this.state.useDefaultValues) {
                  this.setState({ isSaving: true }, () => {
                    this.save();
                  });
                }
              }}
            />
            <IAButton
              label={new LocalizationService().strings.TargetingAdmin_ApplicationSettingsCancel}
              buttonColor={"#999999"}
              style={{ marginLeft: "10px", float: 'right' }}
              onClick={() => {
                this.cleanTargetingExistingStructure();
                this.props.close();
              }}
              disbaled={this.state.isSaving}
            />
          </div>
        }

      </div>);

    return (
      <div>
        {!this.props.isMountOnMainPanel &&
          <IAPanel
            showNavigationBar={true}
            itemId={this.props.targetingStore.userGroupToEdit != undefined && this.props.targetingStore.userGroupToEdit.id !== undefined ? this.props.targetingStore.userGroupToEdit.id : undefined}
            open={this.props.open}
            transition={this.props.targetingStore.userGroupToEdit != undefined ? "fade" : "slide"}
            width={550}
            isMobile={false}
            tenant={this.props.targetingStore.tenant}
            token={this.props.targetingStore.token}
            environment={this.props.targetingStore.environment}
            disableSaving={this.props.targetingStore.userGroupToEdit != undefined && this.props.targetingStore.userGroupToEdit.title === undefined
              || this.props.targetingStore.userGroupToEdit != undefined && this.props.targetingStore.userGroupToEdit.title == ""
            }
            // Actions
            close={() => {
              this.cleanTargetingExistingStructure();
              this.props.close();
            }}
          >{panel}</IAPanel>
        }
        {this.props.isMountOnMainPanel &&
          panel
        }
      </div>
    );
  }


  private save() {
    let isEnable = this.state.enableTargeting;
    let allValues = this.state.allValues;
    let type = this.state.radioValue;

    let data: Instance = undefined;
    let application: IApplication = undefined;
    if (!this.props.isApplication) {
      application = this.props.targetingStore.applicationsData.find(x => x.name === this.props.application.name);
      data = application.instances.find(x => x.id === this.props.item.id);
      data.isEnable = isEnable;
      data.useDefault = (this.props.application.name.toLocaleLowerCase() === 'content organizer') ? false : this.state.useDefaultValues;
      data.allValues = allValues;
      data.values = type === 'userGroups' ? this.state.storedValues.filter(x => x.value) : this.state.treeValues;
      data.type = (this.props.application.name.toLocaleLowerCase() === 'content organizer') ? type : application.default.type

    } else {
      application = this.props.targetingStore.applicationsData.find(x => x.name === this.props.application.name);
      application.default = {
        isEnable,
        type,
        values: type === 'userGroups' ? this.state.storedValues.filter(x => x.value) : this.state.treeValues,
        allValues
      }
    }
    let listObj = {
      id: application.id,
      title: application.title,
      applicationSettings: type === 'userGroups' ? 'User groups' : 'Profile data',
      defaultValues: JSON.stringify(application)
    }

    TargetingService.updateApplicationsTargetSettings(this.props.targetingStore.environment, this.props.targetingStore.tenant, this.props.targetingStore.token,
      listObj, application.id).then(() => {
        this.setState({ storedValues: [], isSaving: false }, () => {
          this.props.close();
        });
      });
  }

  private cleanTargetingExistingStructure = () => {
    this.setState({
      targetingExistingStructure: {
        useDefaultStructure: false,
        nodes: []
      }
    });
  }

}
